import { render } from "./PartyRoomPageList.vue?vue&type=template&id=658b8982"
import script from "./PartyRoomPageList.vue?vue&type=script&lang=js"
export * from "./PartyRoomPageList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__